import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { fetchShopDataApi } from 'store/shopCouponCodes/api';
import { receiveShopData } from 'store/shopCouponCodes/actions';
import { PATHS } from 'consts/paths';

function* fetchShopDataWorker({ payload: { shop } }) {
  try {
    if (!shop) {
      window.location.pathname = PATHS.NOT_FOUND;

      return;
    }

    const { data } = yield call(fetchShopDataApi, shop);

    if (!data?.shop?.name) {
      window.location.pathname = PATHS.NOT_FOUND;

      return;
    }

    yield put(
      receiveShopData({
        couponCodes: data?.offers,
        popularItems: data?.on_sale_items,
        name: data?.shop?.name,
        seoDescriptions: data?.shop?.shop_seo_descriptions,
      }),
    );
  } catch (error) {
    yield put(handleServerError(error));
  }
}

export default fetchShopDataWorker;
